import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProductPreview() {
  return <section className="bg-dark text-white py-20 md:py-32" data-id="element-205">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-206">
        <FadeIn data-id="element-207">
          <h2 className="text-3xl md:text-4xl font-black mb-6" data-id="element-208">
            Tu plan completo, en la palma de tu mano
          </h2>
          <p className="text-xl text-gray-400 mb-16 max-w-2xl mx-auto" data-id="element-209">
            Accedé desde tu celular, tablet o computadora. Llevá tu
            entrenamiento con vos a donde vayas.
          </p>
        </FadeIn>

        <div className="flex flex-col md:flex-row justify-center items-center gap-8 md:gap-12" data-id="element-210">
          <FadeIn delay={0.1} className="w-full max-w-sm" data-id="element-211">
            <div className="relative mx-auto border-gray-800 dark:border-gray-800 bg-gray-800 border-[14px] rounded-[2.5rem] h-[600px] w-[300px] shadow-2xl" data-id="element-212">
              <div className="w-[148px] h-[18px] bg-gray-800 top-0 rounded-b-[1rem] left-1/2 -translate-x-1/2 absolute" data-id="element-213"></div>
              <div className="h-[46px] w-[3px] bg-gray-800 absolute -left-[17px] top-[124px] rounded-l-lg" data-id="element-214"></div>
              <div className="h-[46px] w-[3px] bg-gray-800 absolute -left-[17px] top-[178px] rounded-l-lg" data-id="element-215"></div>
              <div className="h-[64px] w-[3px] bg-gray-800 absolute -right-[17px] top-[142px] rounded-r-lg" data-id="element-216"></div>
              <div className="rounded-[2rem] overflow-hidden w-full h-full bg-white relative" data-id="element-217">
                <img src="https://images.unsplash.com/photo-1526506114861-13419b928f2a?auto=format&fit=crop&w=400&q=80" className="w-full h-full object-cover" alt="App preview" data-id="element-218" />
                <div className="absolute inset-0 bg-dark/40 flex items-center justify-center" data-id="element-219">
                  <div className="bg-white/90 backdrop-blur text-dark px-6 py-3 rounded-full font-bold shadow-lg" data-id="element-220">
                    Día 1: Empezamos
                  </div>
                </div>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.3} className="w-full max-w-sm hidden md:block" data-id="element-221">
            <div className="relative mx-auto border-gray-800 dark:border-gray-800 bg-gray-800 border-[14px] rounded-[2.5rem] h-[600px] w-[300px] shadow-2xl scale-90 opacity-80" data-id="element-222">
              <div className="w-[148px] h-[18px] bg-gray-800 top-0 rounded-b-[1rem] left-1/2 -translate-x-1/2 absolute" data-id="element-223"></div>
              <div className="rounded-[2rem] overflow-hidden w-full h-full bg-white relative" data-id="element-224">
                <img src="https://images.unsplash.com/photo-1552674605-171d31fea3fa?auto=format&fit=crop&w=400&q=80" className="w-full h-full object-cover" alt="App preview 2" data-id="element-225" />
                <div className="absolute inset-0 bg-dark/40 flex items-center justify-center" data-id="element-226">
                  <div className="bg-white/90 backdrop-blur text-dark px-6 py-3 rounded-full font-bold shadow-lg" data-id="element-227">
                    Semana 4: Progreso
                  </div>
                </div>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}